<template>
  <v-container fill-height fluid pl-0 pr-0 align-start>
    <v-layout column>
      <v-flex dark>
        <v-container>

          <v-flex xs12 sm6 offset-sm3 class="l-row setting-card">
            <v-card>
              <v-card-title class="text-upper secondary--text">
                <v-icon color="secondary" class="title-icon">autorenew</v-icon>
                <h3 class="headline">{{ $t('LBL.PASSWORD_RESET') }}</h3>
              </v-card-title>
              <v-card-text>
                <div v-html="$t('TXT.SETTING_PAGE_RESET_PASSWORD_HELP_HTML')"></div>

                <v-form v-model="passwordResetFormValid" ref="passwordResetForm"
                  @submit.prevent.stop="validatePasswordResetForm">
                  <v-text-field name="passwordResetEmail" id="passwordResetEmail" required :label="$t('LBL.EMAIL')"
                    v-model="passwordResetEmail" :rules="passwordResetEmailRules"
                  ></v-text-field>
                </v-form>

              </v-card-text>
              <v-card-actions class="primary">
                <v-btn flat dark @click="validatePasswordResetForm" :disabled="loading">{{ $t('LBL.SEND_RESET_EMAIL')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 offset-sm3 class="l-row setting-card">
            <v-card>
              <v-card-title class="text-upper secondary--text">
                <v-icon color="secondary" class="title-icon">language</v-icon>
                <h3 class="headline">{{ $t('LBL.CHANGE_LANGUAGE') }}</h3>
              </v-card-title>
              <v-card-text>
                <div v-html="$t('TXT.SETTING_PAGE_CHANGE_LANGUAGE_HELP_HTML')"></div>

                <v-form v-model="changeLanguageFormValid" ref="changeLanguageForm">
                  <v-select :label="$t('MSG.PLEASE_CHOOSE_YOUR_LANGUAGE')" required
                    :items="availableLangs"
                    v-model="selectedLang"
                    item-value="code"
                  ></v-select>
                </v-form>

              </v-card-text>
              <v-card-actions class="primary">
                <v-btn flat dark @click="validateChangeLanguageForm" :disabled="loading">{{ $t('LBL.UPDATE_LANGUAGE')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 offset-sm3 class="l-row setting-card">
            <v-card>
              <v-card-title class="text-upper secondary--text">
                <v-icon color="secondary" class="title-icon">delete_forever</v-icon>
                <h3 class="headline">{{ $t('LBL.DELETE_PROFILE') }}</h3>
              </v-card-title>
              <v-card-text>
                <div v-html="$t('TXT.SETTING_PAGE_DELETE_PROFILE_HELP_HTML')"></div>
              </v-card-text>
              <v-card-actions class="primary">
                <v-btn flat dark @click="showProfDelDialog = true" :disabled="loading">{{ $t('LBL.CONFIRM_DELETE') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 offset-sm3 class="l-row setting-card">
            <v-card>
              <v-card-title class="text-upper secondary--text">
                <v-icon color="secondary" class="title-icon">email</v-icon>
                <h3 class="headline">{{ $t('LBL.STOP_EMAILS') }}</h3>
              </v-card-title>
              <v-card-text>
                <div v-html="$t('TXT.SETTING_PAGE_STOP_EMAIL_HELP_HTML')"></div>
              </v-card-text>
              <v-card-actions class="primary">
                <v-btn flat dark @click="updateEmailPreference" :disabled="loading">{{ $t('LBL.STOP_EMAIL') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showPassResetDialog" lazy max-width="500">
      <v-card>
        <v-card-title primary-title class="primary--text">
          <span class="headline">
            {{ $t('LBL.PASS_RESET_DIALOG_TITLE') }}
          </span>
          <v-spacer></v-spacer>
          <v-icon color="primary">email</v-icon>
        </v-card-title>

        <v-card-text v-html="$t('TXT.PASS_RESET_DIALOG_CONTENT_HTML')"></v-card-text>

        <v-card-actions class="primary">
          <v-spacer></v-spacer>
          <v-btn dark flat @click="showPassResetDialog = false">
            {{ $t('LBL.CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showProfDelDialog" lazy max-width="500">
      <v-card color="red accent-4" dark>
        <v-card-title primary-title>
          <span class="headline">
            {{ $t('LBL.DELETE_PROFILE_DIALOG_TITLE') }}
          </span>
        </v-card-title>

        <v-card-text v-html="$t('TXT.DELETE_PROFILE_DIALOG_CONTENT_HTML')"></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteUserProfile">
            <v-icon>close</v-icon>
            {{ $t('LBL.CONFIRM_DELETE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showStopEmailDialog" lazy max-width="500">
      <v-card>
        <v-card-title primary-title class="primary--text">
          <span class="headline">
            {{ $t('LBL.STOP_EMAILS_DIALOG_TITLE') }}
          </span>
        </v-card-title>

        <v-card-actions class="primary">
          <v-spacer></v-spacer>
          <v-btn dark flat @click="showStopEmailDialog = false">
            {{ $t('LBL.CLOSE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'

export default {
  name: 'SettingsPage',
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)
    this.selectedLang = this.userLanguage
  },
  computed: {
    ...mapGetters([
      'userLanguage'
    ]),
    ...mapState([
      'availableLangs'
    ])
  },
  data () {
    return {
      passwordResetEmailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.EMAIL')}),
        v => /^\w+([.-]?\w+)*([+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('RULE.FIELD_INVALID_VALUE', {FIELD: this.$i18n.t('LBL.EMAIL')})
      ],
      passwordResetFormValid: null,
      passwordResetEmail: '',
      changeLanguageFormValid: null,
      selectedLang: null,
      loading: false,

      showPassResetDialog: false,
      showProfDelDialog: false,
      showStopEmailDialog: false
    }
  },
  methods: {
    updateEmailPreference () {
      const data = {
        pref: true
      }

      if (this.loading) {
        return
      }

      this.loading = true

      this.doUpdateEmailPref(data)
        .then(() => {
          this.showStopEmailDialog = true
        })
        .catch((error) => {
          this.showMessage({
            text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
            color: 'error'
          })
        })
        .finally(() => { this.loading = false })
    },
    validatePasswordResetForm () {
      if (this.$refs.passwordResetForm.validate()) {
        const data = {
          email: this.passwordResetEmail,
          language: this.userLanguage
        }

        if (this.loading) {
          return
        }

        this.loading = true

        this.doRequestPasswordReset(data)
          .then(() => {
            this.showPassResetDialog = true
            this.$refs.passwordResetForm.reset()
          })
          .catch((error) => {
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    validateChangeLanguageForm () {
      if (this.$refs.changeLanguageForm.validate()) {
        const data = {
          language: this.selectedLang
        }

        if (this.loading) {
          return
        }

        this.loading = true

        this.doUpdateLangage(data)
          .then(() => {
            this.showMessage({
              text: this.$root.$i18n.t('MSG.LANGUAGE_UPDATE_SUCCESS'),
              color: 'success'
            })
          })
          .catch((error) => {
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
          .finally(() => { this.loading = false })
      }
    },
    deleteUserProfile () {
      if (this.loading) {
        return
      }

      this.loading = true

      this.doDeleteUserProfile()
        .then(() => {
          this.showProfDelDialog = false

          this.showMessage({
            text: this.$root.$i18n.t('MSG.DELETE_PROFILE_SUCCESS'),
            color: 'success'
          })

          this.$router.push('/start')
        })
        .catch((error) => {
          this.showMessage({
            text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
            color: 'error'
          })
        })
        .finally(() => { this.loading = false })
    },
    ...mapActions({
      doRequestPasswordReset: 'requestPasswordReset',
      doUpdateEmailPref: 'updateEmailPreference',
      doUpdateLangage: 'updateUserLanguage',
      doDeleteUserProfile: 'deleteUserProfile'
    }),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    ServerErrorMixin
  ]
}
</script>

<style lang="scss" scoped>
.setting-card {
  .card__title {
    padding: 24px 24px 10px;

    .title-icon {
      margin-right: 5px;
    }
  }

  .card__text {
    padding: 0 24px 24px;

    & /deep/ ol {
      padding-left: 2.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/SettingsPage.vue